import { gql } from '@apollo/client';
import { Comment } from 'graphql/main/queries/temp/comments';
import { MutationOf } from 'graphql/upload/mutations';

export interface CommnentMutation extends MutationOf {
  data?: Comment;
}

export interface LikeCommentVariables {
  commentId: string;
}
export interface LikeCommentData {
  likeComment?: CommnentMutation;
}

export const LIKE_COMMENT = gql`
  mutation likeComment($commentId: ID!) @api(name: social) {
    likeComment(commentId: $commentId) {
      msg
      success
    }
  }
`;
